// extracted by mini-css-extract-plugin
export default {"container":"SelectGroup_container__ZjAQE","tagContainer":"SelectGroup_tagContainer__t1j3B"};